import { ADDITIONAL_PARTICIPANT_EVENTS } from '../../../event_bus_modules/additional_participant';
import { ADDITIONAL_DETAILS_EVENTS } from '../../../event_bus_modules/additional_details';

$(() => {
  const purchasingWithSomeoneElse = $('.purchasing-with-someone-else');
  const isRequired =
    purchasingWithSomeoneElse.find('input[name="is-mandatory"]').val() ===
    'True';
  const addedPersonsSection = purchasingWithSomeoneElse.find(
    '.additional-participant__added-persons'
  );

  const hasAddedPersons = () => {
    return addedPersonsSection.children().length;
  };

  const initializePurchasingWithSomeoneElse = (htmlElement) => {
    const element = $(htmlElement);

    const additionalPurchasersYesButton = element.find(
      '#invited-via-emails-yes-button'
    );
    const additionalPurchasersNoButton = element.find(
      '#invited-via-emails-no-button'
    );
    const additionalPurchasersContainer = element.find(
      '#invited-via-emails-container'
    );
    const purchasingWithSomeoneElseInput = element.find(
      'input[name="purchasing-with-someone-else"]'
    );

    const updateSectionValidationState = () => {
      if (isRequired) {
        const purchasingWithSomeoneElseValue = purchasingWithSomeoneElseInput.val();
        let valid = true;

        if (purchasingWithSomeoneElseValue === 'yes') {
          valid = hasAddedPersons();
        } else if (purchasingWithSomeoneElseValue === 'no') {
          valid = true;
        } else {
          valid = false;
        }

        const eventType = valid
          ? ADDITIONAL_DETAILS_EVENTS.REMOVE_ERROR
          : ADDITIONAL_DETAILS_EVENTS.ADD_ERROR;

        EVENT_BUS.dispatch(eventType, {
          error: ADDITIONAL_DETAILS_EVENTS.ERROR.PURCHASING_WITH_SOMEONE,
        });
      }
    };

    const showAdditionalPurchasers = () => {
      additionalPurchasersYesButton.addClass('active');
      additionalPurchasersNoButton.removeClass('active');
      additionalPurchasersContainer.removeClass('d-none');
      purchasingWithSomeoneElseInput.val('yes');
      updateSectionValidationState();
    };

    const hideAdditionalPurchasers = () => {
      if (purchasingWithSomeoneElseInput.val() !== 'no') {
        additionalPurchasersYesButton.removeClass('active');
        additionalPurchasersNoButton.addClass('active');
        additionalPurchasersContainer.addClass('d-none');
        purchasingWithSomeoneElseInput.val('no');
        EVENT_BUS.dispatch(
          ADDITIONAL_PARTICIPANT_EVENTS.RESET_PARTICIPANT_FORM,
          {
            type: 'ADDITIONAL_PURCHASER',
          }
        );
        updateSectionValidationState();
      }
    };

    if (purchasingWithSomeoneElseInput.val() == 'True') {
      showAdditionalPurchasers();
    } else if (purchasingWithSomeoneElseInput.val() == 'False') {
      hideAdditionalPurchasers();
    } else {
      purchasingWithSomeoneElseInput.val('');
    }

    additionalPurchasersYesButton.on('click', showAdditionalPurchasers);
    additionalPurchasersNoButton.on('click', hideAdditionalPurchasers);
    EVENT_BUS.on(ADDITIONAL_PARTICIPANT_EVENTS.REMOVED_PARTICIPANT, () => {
      updateSectionValidationState();
    });
    EVENT_BUS.on(
      ADDITIONAL_PARTICIPANT_EVENTS.ADDED_SELECTED_PARTICIPANT,
      () => {
        updateSectionValidationState();
      }
    );
    EVENT_BUS.on(ADDITIONAL_PARTICIPANT_EVENTS.ADDED_NEW_PARTICIPANT, () => {
      updateSectionValidationState();
    });
    updateSectionValidationState();
  };

  purchasingWithSomeoneElse.each((_, element) =>
    initializePurchasingWithSomeoneElse(element)
  );
});
